var $2c29d48084ee6251$exports = {};
$2c29d48084ee6251$exports = {
    "Empty": `Prazen`
};


export {$2c29d48084ee6251$exports as default};
//# sourceMappingURL=sl-SI.mjs.map
